var React = require('react');

function InputArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.0859 16.8L18.3999 11.486M18.3999 11.486L13.0859 6.17199M18.3999 11.486H5.59991C3.39077 11.486 1.5999 9.69514 1.5999 7.486V1.20001","stroke":"#A2A2A2","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

InputArrow.defaultProps = {"width":"40","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = InputArrow;

InputArrow.default = InputArrow;
